<template>
  <b-card>
    <table-messages />
  </b-card>
</template>

<script>
import TableMessages from '@/layouts/components/TableMessages.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    TableMessages,
  },
}
</script>
